import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@hq-app/app.module';
import { Amplify } from 'aws-amplify';
import { environment } from '@hq-environments/environment';

if (environment.useProductionMode) {
    enableProdMode();
}

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: environment.userPoolId,
            userPoolClientId: environment.cognitoClientId,
            identityPoolId: environment.identityPoolId
        }
    }
});

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => {
        // eslint-disable-next-line no-console
        console.log(err);
    });
